import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { addStatistics } from '@/pages/goods-new/require';
import { env } from '@ivy/fts/envInfo/envInfo';
import showDiv from '@ivy/fts/showDiv';
import guideVip from './guideVip.vue';
let CouponListPopup = class CouponListPopup extends Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.coupons = [];
        this.unCoupons = [];
        this.vipCoupons = [];
        this.curType = 'all'; // 当前选中的优惠券类型
    }
    get popupVisible() {
        return this.visible;
    }
    get curCoupon() {
        return this.coupons.find(v => v.id === this.userCouponId);
    }
    get couponsFilter() {
        return this.curType === 'vip' ? this.vipCoupons : this.coupons;
    }
    get couponTimeRange() {
        return coupon => {
            let start = (coupon.use_start_time || '').replace(/-/g, '.').slice(0, 16);
            let end = (coupon.use_end_time || '').replace(/-/g, '.').slice(0, 16);
            if (start && end) {
                return start + ' - ' + end;
            }
            if (start) {
                return start;
            }
            if (end) {
                return end;
            }
            return '';
        };
    }
    get isSameCoupon() {
        return coupon => {
            return (this.userCouponId === coupon.id &&
                this.couponUserId === coupon.coupon_user_id);
        };
    }
    async created() {
        await env.init();
        // await this.$store.login()
        if (this.mode === 'select') {
            this.coupons = this.originCoupons;
            this.unCoupons = this.originUnCoupons;
            this.loading = false;
        }
        else {
            this.getProcessingCoupons();
        }
    }
    async getProcessingCoupons() {
        let { data } = await this.$axios.get(`/api/goods/shop/search/coupon/getProcessingCouponByGoods`, {
            params: {
                spuId: this.product.spuId,
                offset: 0,
                limit: 20,
            },
        });
        this.loading = false;
        this.coupons = data;
        if (this.showVip) {
            let { data: vipData } = await this.$axios.get(`/api/goods/shop/search/coupon/getProcessingCouponByGoods`, {
                params: {
                    spuId: +this.$route.query.spuId || 0,
                    offset: 0,
                    limit: 20,
                    isVip: '1',
                },
            });
            this.vipCoupons = vipData;
            if (!this.coupons.length)
                this.curType = 'vip';
        }
    }
    async acquireCoupon(coupon) {
        // 埋点 点击领取优惠券
        addStatistics({
            event: 'Click_GetCoupons_H5',
            p1: this.$route.query.spuId,
            p2: coupon.activity_id,
            p3: this.goodsStatus,
        });
        if (coupon.coupon_type === 'vip') {
            await env.init();
            let info = await env.getInfo();
            let isVip = false;
            if (env.type === 'ivydad') {
                isVip = Boolean(+info.userInfo.isVip);
            }
            else if (env.type === 'wx') {
                isVip = info.logined && info.logined.vip;
            }
            if (!isVip) {
                showDiv(guideVip, {});
                return;
            }
        }
        if (coupon.collected_num >= coupon.per_count &&
            coupon.receive_status !== 1) {
            return this.$Toast('领取数量已达上限了喔');
        }
        const { data } = await this.$axios.post(`/api/goods/shop/search/coupon/acquireCoupon`, {
            activityId: coupon.activity_id,
        });
        this.getProcessingCoupons();
        if (data.code) {
            return this.$Toast(data.message);
        }
        return this.$Toast('领取成功啦');
    }
    tabIndexChange(type) {
        this.curType = type;
    }
    onCheck(coupon) {
        if (!coupon)
            return this.hide(this.curCoupon);
        if (this.userCouponId === coupon.id &&
            this.couponUserId === coupon.coupon_user_id) {
            this.hide({});
        }
        else {
            this.hide(coupon);
        }
    }
    hide(r) {
        this.close(r || {});
    }
};
tslib_1.__decorate([
    Prop()
], CouponListPopup.prototype, "visible", void 0);
tslib_1.__decorate([
    Prop()
], CouponListPopup.prototype, "close", void 0);
tslib_1.__decorate([
    Prop()
], CouponListPopup.prototype, "originCoupons", void 0);
tslib_1.__decorate([
    Prop()
], CouponListPopup.prototype, "originUnCoupons", void 0);
tslib_1.__decorate([
    Prop()
], CouponListPopup.prototype, "mode", void 0);
tslib_1.__decorate([
    Prop()
], CouponListPopup.prototype, "userCouponId", void 0);
tslib_1.__decorate([
    Prop()
], CouponListPopup.prototype, "couponUserId", void 0);
tslib_1.__decorate([
    Prop()
], CouponListPopup.prototype, "goodsStatus", void 0);
tslib_1.__decorate([
    Prop({ default: { spuId: 0 } })
], CouponListPopup.prototype, "product", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], CouponListPopup.prototype, "showVip", void 0);
CouponListPopup = tslib_1.__decorate([
    Component({
        filters: {
            couponType: type => {
                return {
                    all: '通用券',
                    designation: '商品券',
                }[type];
            },
            thresholdPrice: num => {
                const number = +num;
                return number ? `满${number.toFixed()}可用` : '无门槛';
            },
            numberFixed: num => {
                const number = +num;
                return number ? `${number.toFixed()}` : '0';
            },
            toSecond: time => {
                if (!time)
                    return time;
                return time.replace(/-/g, '.').slice(0, 16);
            },
        },
    })
], CouponListPopup);
export default CouponListPopup;
